import React, { useEffect, useState } from "react";
// import { useDetectClickOutside } from 'react-detect-click-outside'
import { useDebounce } from "use-debounce";
import {
  // ActionBar,
  BoxComponentStyled,
  // BoxFilterContainer,
  BoxSearchContainer,
  GoButton,
  // CloseButton, DropDownStyled,
  InputSearch,
  LabelSearch,
  Wrapper,
} from "./styled";

type ComponentProps = {
  children?: any;
  handleFilter: any;
  searchLabel?: string;
  // filterComponent?: any
  placehoderSearch?: string;
};

const FilterBar = ({
  searchLabel,
  children,
  handleFilter,
  placehoderSearch,
}: ComponentProps): JSX.Element => {
  const [open, setOpenDropDown] = useState<boolean>(false);
  const [close, setClose] = useState<boolean>(false);
  const [text, setText] = useState();
  const [value] = useDebounce(text, 100);

  const closeDropdown = (): void => {
    if (open) {
      setOpenDropDown(false);
    }
  };
  useEffect(() => {
    if (close) {
      closeDropdown();
      setClose(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [close, handleFilter]);

  return (
    <Wrapper>
      <BoxComponentStyled>
        <BoxSearchContainer>
          <LabelSearch>{searchLabel}</LabelSearch>
          <InputSearch
            value={text}
            onChange={(e: any) => setText(e.target.value)}
            placeholder={placehoderSearch || "Buscar"}
          />
          <GoButton
            onClick={() => {
              if (value) {
                handleFilter((prev: any) => ({ ...prev, query: `${value}` }));
              }
              if (!value) {
                handleFilter((prev: any) => ({ ...prev, query: "" }));
              }
            }}
          >
            Ir
          </GoButton>
        </BoxSearchContainer>
      </BoxComponentStyled>
      {children}
    </Wrapper>
  );
};
export default FilterBar;
